import { AppState } from 'src/state/store'

export const exchangeModalStateSelector = (state: AppState): boolean =>
  state.exchangeModal.isOpened
